const ahua = {
  blue: {
    scale0: 'hsla(209,100%,95%,1)',
    scale5: 'hsla(211,100%,90%,1)',
    scale10: 'hsla(212,100%,86%,1)',
    scale20: 'hsla(213,96%,77%,1)',
    scale30: 'hsla(213,90%,68%,1)',
    scale40: 'hsla(212,83%,58%,1)',
    scale50: 'hsla(208,92%,45%,1)',
    scale60: 'hsla(210,100%,40%,1)',
    scale70: 'hsla(212,100%,36%,1)',
    scale80: 'hsla(213,100%,31%,1)',
    scale90: 'hsla(216,92%,27%,1)',
    scale100: 'hsla(221,74%,24%,1)',
  },
  green: {
    scale0: 'hsla(64,45%,91%,1)',
    scale5: 'hsla(66,49%,85%,1)',
    scale10: 'hsla(68,50%,80%,1)',
    scale20: 'hsla(71,51%,69%,1)',
    scale30: 'hsla(74,50%,58%,1)',
    scale40: 'hsla(77,52%,48%,1)',
    scale50: 'hsla(78,78%,38%,1)',
    scale60: 'hsla(79,100%,30%,1)',
    scale70: 'hsla(82,100%,27%,1)',
    scale80: 'hsla(84,100%,23%,1)',
    scale90: 'hsla(86,100%,19%,1)',
    scale100: 'hsla(87,100%,16%,1)',
  },
  brown: {
    scale0: 'hsla(19,46%,94%,1)',
    scale5: 'hsla(20,41%,88%,1)',
    scale10: 'hsla(20,39%,82%,1)',
    scale20: 'hsla(21,35%,70%,1)',
    scale30: 'hsla(22,32%,59%,1)',
    scale40: 'hsla(23,33%,49%,1)',
    scale50: 'hsla(24,38%,41%,1)',
    scale60: 'hsla(25,45%,34%,1)',
    scale70: 'hsla(25,50%,29%,1)',
    scale80: 'hsla(25,52%,24%,1)',
    scale90: 'hsla(26,53%,21%,1)',
    scale100: 'hsla(26,52%,18%,1)',
  },
  yellow: {
    scale0: 'hsla(45,64%,92%,1)',
    scale5: 'hsla(45,82%,89%,1)',
    scale10: 'hsla(45,91%,85%,1)',
    scale20: 'hsla(46,98%,79%,1)',
    scale30: 'hsla(46,98%,72%,1)',
    scale40: 'hsla(45,94%,65%,1)',
    scale50: 'hsla(45,87%,57%,1)',
    scale60: 'hsla(44,81%,49%,1)',
    scale70: 'hsla(43,100%,41%,1)',
    scale80: 'hsla(40,100%,36%,1)',
    scale90: 'hsla(38,100%,31%,1)',
    scale100: 'hsla(35,100%,25%,1)',
  },
  red: {
    scale0: 'hsla(341,100%,96%,1)',
    scale5: 'hsla(344,100%,92%,1)',
    scale10: 'hsla(346,100%,89%,1)',
    scale20: 'hsla(350,100%,81%,1)',
    scale30: 'hsla(352,93%,74%,1)',
    scale40: 'hsla(353,80%,65%,1)',
    scale50: 'hsla(354,68%,55%,1)',
    scale60: 'hsla(354,65%,47%,1)',
    scale70: 'hsla(355,74%,39%,1)',
    scale80: 'hsla(356,79%,32%,1)',
    scale90: 'hsla(359,79%,27%,1)',
    scale100: 'hsla(5,89%,21%,1)',
  },
  orange: {
    scale0: 'hsla(26,100%,94%,1)',
    scale5: 'hsla(27,100%,90%,1)',
    scale10: 'hsla(28,100%,85%,1)',
    scale20: 'hsla(27,100%,78%,1)',
    scale30: 'hsla(26,100%,71%,1)',
    scale40: 'hsla(25,96%,64%,1)',
    scale50: 'hsla(25,85%,57%,1)',
    scale60: 'hsla(24,74%,50%,1)',
    scale70: 'hsla(23,79%,44%,1)',
    scale80: 'hsla(21,81%,38%,1)',
    scale90: 'hsla(18,79%,33%,1)',
    scale100: 'hsla(16,77%,28%,1)',
  },
  black: {
    scale0: 'hsla(0,0%,6%,0.02)',
    scale5: 'hsla(0,0%,6%,0.05)',
    scale10: 'hsla(0,0%,6%,0.1)',
    scale15: 'hsla(0,0%,6%,0.15)',
    scale20: 'hsla(0,0%,6%,0.2)',
    scale30: 'hsla(0,0%,6%,0.3)',
    scale40: 'hsla(0,0%,6%,0.4)',
    scale50: 'hsla(0,0%,6%,0.5)',
    scale60: 'hsla(0,0%,6%,0.6)',
    scale70: 'hsla(0,0%,6%,0.7)',
    scale80: 'hsla(0,0%,6%,0.8)',
    scale90: 'hsla(0,0%,6%,0.9)',
    scale100: 'hsla(0,0%,6%,0.97)',
  },
  white: {
    scale0: 'hsla(0,0%,100%,0)',
    scale5: 'hsla(0,0%,100%,0.05)',
    scale10: 'hsla(0,0%,100%,0.1)',
    scale20: 'hsla(0,0%,100%,0.2)',
    scale30: 'hsla(0,0%,100%,0.3)',
    scale40: 'hsla(0,0%,100%,0.4)',
    scale50: 'hsla(0,0%,100%,0.5)',
    scale60: 'hsla(0,0%,100%,0.6)',
    scale70: 'hsla(0,0%,100%,0.7)',
    scale80: 'hsla(0,0%,100%,0.8)',
    scale90: 'hsla(0,0%,100%,0.9)',
    scale100: 'hsla(0,0%,100%,1)',
  },
  gray: {
    scale0: 'hsla(33,12%,96%,1)',
    scale5: 'hsla(33,12%,94%,1)',
    scale10: 'hsla(33,8%,92%,1)',
    scale20: 'hsla(33,8%,86%,1)',
    scale30: 'hsla(33,8%,80%,1)',
    scale40: 'hsla(33,6%,66%,1)',
    scale50: 'hsla(33,6%,50%,1)',
    scale60: 'hsla(33,6%,38%,1)',
    scale70: 'hsla(33,8%,24%,1)',
    scale80: 'hsla(33,6%,14%,1)',
    scale90: 'hsla(33,8%,10%,1)',
    scale100: 'hsla(33,8%,6%,1)',
  },
  purple: {
    scale0: 'hsla(254,100%,97%,1)',
    scale5: 'hsla(253,100%,94%,1)',
    scale10: 'hsla(253,100%,91%,1)',
    scale20: 'hsla(253,100%,85%,1)',
    scale30: 'hsla(253,89%,78%,1)',
    scale40: 'hsla(254,78%,71%,1)',
    scale50: 'hsla(254,67%,64%,1)',
    scale60: 'hsla(255,55%,56%,1)',
    scale70: 'hsla(256,47%,49%,1)',
    scale80: 'hsla(258,50%,41%,1)',
    scale90: 'hsla(259,52%,34%,1)',
    scale100: 'hsla(260,54%,27%,1)',
  },
  transparent: 'rgba(0,0,0,0)',
};

const colorType = {
  brand: {
    lightest: ahua.blue.scale0,
    lighter: ahua.blue.scale10,
    light: ahua.blue.scale30,
    base: ahua.blue.scale50,
    contrast: ahua.blue.scale60,
    dark: ahua.blue.scale70,
    darker: ahua.blue.scale80,
    darkest: ahua.blue.scale100,
  },
  destructive: {
    lightest: ahua.red.scale0,
    lighter: ahua.red.scale10,
    light: ahua.red.scale30,
    base: ahua.red.scale50,
    contrast: ahua.red.scale60,
    dark: ahua.red.scale70,
    darker: ahua.red.scale80,
    darkest: ahua.red.scale100,
  },
  success: {
    lightest: ahua.green.scale0,
    lighter: ahua.green.scale10,
    light: ahua.green.scale30,
    base: ahua.green.scale50,
    contrast: ahua.green.scale60,
    dark: ahua.green.scale70,
    darker: ahua.green.scale80,
    darkest: ahua.green.scale100,
  },
  warning: {
    lightest: ahua.orange.scale0,
    lighter: ahua.orange.scale10,
    light: ahua.orange.scale30,
    base: ahua.orange.scale50,
    contrast: ahua.orange.scale60,
    dark: ahua.orange.scale70,
    darker: ahua.orange.scale80,
    darkest: ahua.orange.scale100,
  },
  inverse: {
    lightest: ahua.white.scale5,
    lighter: ahua.white.scale10,
    light: ahua.white.scale20,
    base: ahua.white.scale50,
    contrast: ahua.white.scale70,
    dark: ahua.white.scale80,
    darker: ahua.white.scale90,
    darkest: ahua.white.scale100,
  },
  neutral: {
    lightest: ahua.black.scale5,
    lighter: ahua.black.scale30,
    light: ahua.black.scale40,
    base: ahua.black.scale50,
    contrast: ahua.black.scale60,
    dark: ahua.black.scale70,
    darker: ahua.black.scale80,
    darkest: ahua.black.scale100,
  },
  grayscale: {
    lightest: ahua.gray.scale0,
    lighter: ahua.gray.scale10,
    light: ahua.gray.scale30,
    base: ahua.gray.scale50,
    contrast: ahua.gray.scale60,
    dark: ahua.gray.scale70,
    darker: ahua.gray.scale80,
    darkest: ahua.gray.scale100,
  },
};

const fillColorType = {
  input: {
    enabled: ahua.black.scale5,
    hover: ahua.black.scale10,
    pressed: ahua.black.scale15,
    focusHover: colorType.brand.lightest,
    success: colorType.success.lightest,
    error: colorType.destructive.lightest,
    disabled: ahua.black.scale0,
  },
  actionPrimaryBrand: {
    enabled: colorType.brand.dark,
    hover: colorType.brand.dark,
    pressed: colorType.brand.darker,
  },
  actionPrimaryDestructive: {
    enabled: colorType.destructive.dark,
    hover: colorType.destructive.dark,
    pressed: colorType.destructive.darker,
  },
  actionPrimarySuccess: {
    enabled: colorType.success.dark,
    hover: colorType.success.dark,
    pressed: colorType.success.darker,
  },
  actionPrimaryNeutral: {
    enabled: colorType.neutral.dark,
    hover: colorType.neutral.dark,
    pressed: colorType.neutral.darker,
  },
  actionSecondaryBrand: {
    enabled: colorType.brand.lightest,
    hover: ahua.blue.scale5,
    pressed: colorType.brand.lighter,
  },
  actionSecondaryDestructive: {
    enabled: colorType.destructive.lightest,
    hover: ahua.red.scale5,
    pressed: colorType.destructive.lighter,
  },
  actionSecondarySuccess: {
    enabled: colorType.success.lightest,
    hover: ahua.green.scale5,
    pressed: colorType.success.lighter,
  },
  actionSecondaryNeutral: {
    enabled: colorType.neutral.lightest,
    hover: ahua.black.scale5,
    pressed: colorType.neutral.lighter,
  },
};

const borderColorType = {
  input: {
    enabled: ahua.black.scale30,
    hover: ahua.black.scale40,
    pressed: ahua.black.scale50,
    focus: colorType.brand.base,
    success: colorType.success.base,
    error: colorType.destructive.base,
    disabled: ahua.black.scale10,
  },
  stroke: {
    primary: ahua.black.scale30,
    secondary: ahua.black.scale20,
    tertiarty: ahua.black.scale10,
  },
  action: {
    neutral: colorType.neutral.light,
    focus: colorType.brand.light,
    destructive: colorType.destructive.light,
    success: colorType.success.light,
  },
};

const textColorType = {
  neutral: {
    primary: colorType.neutral.darkest,
    secondary: colorType.neutral.darker,
    tertiary: colorType.neutral.contrast,
    quaternary: colorType.neutral.base,
  },
  inverse: {
    primary: colorType.inverse.darkest,
    secondary: colorType.inverse.darker,
    tertiary: colorType.inverse.contrast,
    quaternary: colorType.inverse.base,
  },
  fill: {
    neutral: colorType.grayscale.lightest,
    brand: 'hsl(210,33%,96%)',
    white: colorType.inverse.darkest,
  },
  primary: {
    light: colorType.grayscale.light,
    base: colorType.grayscale.base,
    dark: colorType.grayscale.dark,
  },
  secondary: {
    light: colorType.grayscale.light,
    base: colorType.grayscale.contrast,
    dark: colorType.grayscale.dark,
  },
};

export default {
  ahua,
  colorType,
  fillColorType,
  borderColorType,
  textColorType,
};
